import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

const Partner = () => {
  return (
    <div className="partner-usa p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                        <div className="partner_content">
                                <h2>Transform Cross-Platform Excellence with Our React Native mobile app development services</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                       <p>Board on a journey of success with TekRevol for multi-platform success. Our React Native application development services reform possibilities, providing unmatched efficiency. Partner with our attuned team and explore the awards that mark our status in the line of illustrious React Native app development companies.</p>
                    </Col>
                </Row>
                <Row className="h-100 partner_padd">
                <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
                    <div className="partner-num">
                        3rd
                    </div>
                    <div className="partner-para">
                        <p>Right Firms Top Mobile App Development Company 2023</p>
                    </div>
                </Col> 
                <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
                    <div className="partner-num">
                        4th
                    </div>
                    <div className="partner-para">
                        <p>INC. 5000 America's Fastest Growing Companies</p>
                    </div>
                </Col> 
                <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
                    <div className="partner-num">
                         4.9
                    </div>
                    <div className="partner-para">
                        <p>Average Review Rating on Clutch</p>
                    </div>
                </Col> 
                </Row>
            </Container>
    </div>
  )
}

export default Partner